var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNhnsolution4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2137_19239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0137 22.4736C30.4191 10.2349 47.7276 10.2349 52.1331 22.4736V22.4736H26.0137V22.4736Z",
    fill: "url(#paint0_linear_2137_19239)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8302 22.4736C15.0687 22.4736 12.8302 24.7122 12.8302 27.4736V53.1348H7.60352V59.5923H70.5419V53.1348H65.3152V27.4736C65.3152 24.7122 63.0767 22.4736 60.3152 22.4736H17.8302Z",
    fill: "url(#paint1_linear_2137_19239)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.0859,
    y: 27.5854,
    width: 3.41406,
    height: 3.41406,
    rx: 1.70703,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.0859,
    y: 27.5854,
    width: 3.41406,
    height: 3.41406,
    rx: 1.70703,
    fill: "url(#paint2_linear_2137_19239)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 27.5854,
    width: 3.41406,
    height: 3.41406,
    rx: 1.70703,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 27.5854,
    width: 3.41406,
    height: 3.41406,
    rx: 1.70703,
    fill: "url(#paint3_linear_2137_19239)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.9141,
    y: 27.5854,
    width: 3.41406,
    height: 3.41406,
    rx: 1.70703,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.9141,
    y: 27.5854,
    width: 3.41406,
    height: 3.41406,
    rx: 1.70703,
    fill: "url(#paint4_linear_2137_19239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.418 43.4907C22.418 40.7293 24.6565 38.4907 27.418 38.4907H29.2373C31.9987 38.4907 34.2373 40.7293 34.2373 43.4907V52.9517H22.418V43.4907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.418 43.4907C22.418 40.7293 24.6565 38.4907 27.418 38.4907H29.2373C31.9987 38.4907 34.2373 40.7293 34.2373 43.4907V52.9517H22.418V43.4907Z",
    fill: "url(#paint5_linear_2137_19239)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6415 22.4736C48.88 22.4736 46.6415 24.7122 46.6415 27.4736V53.1348H41.6016V59.5923H70.5402V53.1348H65.3135V27.4736C65.3135 24.7122 63.075 22.4736 60.3135 22.4736H51.6415Z",
    fill: "url(#paint6_linear_2137_19239)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19239",
    x1: 30.4632,
    y1: 8.79654,
    x2: 14.2092,
    y2: 36.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43A4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2137_19239",
    x1: 39.0727,
    y1: 22.4736,
    x2: -1.4575,
    y2: 67.2114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ECCD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2137_19239",
    x1: 18.2719,
    y1: 27.5854,
    x2: 16.9888,
    y2: 33.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43A4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2137_19239",
    x1: 22.686,
    y1: 27.5854,
    x2: 21.4029,
    y2: 33.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43A4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2137_19239",
    x1: 27.1,
    y1: 27.5854,
    x2: 25.8169,
    y2: 33.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43A4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2137_19239",
    x1: 29.9857,
    y1: 38.4907,
    x2: 23.484,
    y2: 62.7587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43A4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2137_19239",
    x1: 60.1306,
    y1: 22.4736,
    x2: 42.7501,
    y2: 84.3546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43A4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0634B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2137_19239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white",
    transform: "translate(0.277344 0.490723)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhnsolution4);
export default __webpack_public_path__ + "static/media/nhnsolution4.2135036275df30fb515dae259607cc0a.svg";
export { ForwardRef as ReactComponent };